import React from 'react';
import {observer} from 'mobx-react';
import classNames from "classnames";
import styles from "../styles/footer.module.scss";
import {DisclaimerRequestParams} from "../../../../../core/icons/images/disclaimer/disclaimer.request-params";
import {Image} from "../../../../../core/components/image/image";
import {FooterModuleCountryCompliance} from "./footer-module.country-compliance";

export const FooterModuleDisclaimer = observer(({controller}) => {
  const {state} = controller
  const {disclaimerId} = state;

  const imageProps = {
    src: new DisclaimerRequestParams(344, 24, disclaimerId)
  }

  return (
    <div className={classNames(styles.search_container)}>
      <Image {...imageProps}/>
      <FooterModuleCountryCompliance controller={controller}/>
    </div>
  );
});
